/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';

import { getActiveProfile, getIsMainProfile, getIsActiveProfileResidenceUSA } from '../../redux/reduxSelectors';
import { userSelectors } from '../../../redux/selectors_authorizedApp';

import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import AppNavTopLevel from '../../../components/appNav/AppNavTopLevel';
import ContentFrame from '../../../applicationFrame/ContentFrame';

import { ScrollAwareContext } from '../../../components/ScrollAware';

import DataConnectionNotAllowed from './DataConnectionNotAllowed';
import DataConnectionAllowed from './DataConnectionAllowed';

interface ViewDataConnectionsProps {
  profileName: string;
  isMainProfile: boolean;
  isResidenceUSA: boolean;
  preferredLanguage: string;
  profileId: number;
}

class ViewDataConnections extends React.Component<ViewDataConnectionsProps, {}> {

  render() {
    const { profileName, isMainProfile, isResidenceUSA, preferredLanguage, profileId } = this.props;

    const titlePhrase = isMainProfile ? {
      id: 'dataConnections.user.title.text',
    } : {
      id: 'dataConnections.notUser.title.text',
      values: {
        string1: profileName,
      },
    };

    return (
      <div className="cmp-mybackpack">
        <ScrollAwareContext>
          <AppNavTopLevel hasDropShadow />

          <ContentFrame>
            <div>
              <AppHeaderScrollableText {...titlePhrase} />

              {
                isResidenceUSA
                ? <DataConnectionAllowed
                    profileId={profileId}
                    isMainProfile={isMainProfile}
                    preferredLanguage={preferredLanguage}
                    profileName={profileName}
                  />
                : <DataConnectionNotAllowed />
              }
            </div>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const profile = getActiveProfile(state);

  return {
    profileName: profile.greetingName(),
    preferredLanguage: userSelectors.getPreferredLanguageCode(state),
    isMainProfile: getIsMainProfile(state),
    isResidenceUSA: getIsActiveProfileResidenceUSA(state),
    profileId: profile.data.id,
  };
}

export default connect(mapStateToProps)(ViewDataConnections);
